// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { useState } from 'react';

// Which kind sections of a file list are folded, keyed by section type. Every section starts
// open and nothing persists, so a reload opens them all again (AUT-6669).
export const useSectionFolds = () => {
  const [folded, setFolded] = useState<Record<string, boolean>>({});

  const isOpen = (type: string) => !folded[type];
  const toggle = (type: string) => setFolded((prev) => ({ ...prev, [type]: !prev[type] }));

  return { isOpen, toggle };
};

export default useSectionFolds;
